export default __webpack_public_path__ + "static/media/logo-footer.dbd82859.png";